import { render, staticRenderFns } from "./email-actions-dropdown.vue?vue&type=template&id=55f850f4"
import script from "./email-actions-dropdown.vue?vue&type=script&lang=js"
export * from "./email-actions-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports